<template>
  <div>
    <gmap-marker
      v-if="position.lat !== 0 || position.lng !== 0"
      :position="position"
      :icon="getMarkerIcon()"
      @click="handleMarkerClick"
    />
  </div>
</template>

<script>
export default {
  name: "GoogleMapMarker",
  props: {
    position: {
      type: Object,
      required: true
    },
    primary: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      renderWaypoints: false
    };
  },
  methods: {
    handleMarkerClick() {
      this.$emit("marker-clicked", this.position);
    },
    getMarkerIcon() {
      const iconSize = new google.maps.Size(32, 32);

      if (this.position.lat === 0 && this.position.lng === 0) {
        return null;
      }

      if (this.primary) {
        return {
          url: "https://maps.google.com/mapfiles/kml/paddle/blu-circle.png",
          scaledSize: iconSize
        };
      } else {
        return {
          url: "https://maps.google.com/mapfiles/ms/icons/green-dot.png",
          scaledSize: iconSize
        };
      }
    }
  },
  mounted() {
    this.renderWaypoints = true;
    this.$emit("render-waypoints", this.renderWaypoints);
  }
};
</script>
